<!--
   본 소프트웨어는 관련 법률에 따라 보호되는 삼성의 지식재산 및 영업비밀 입니다. 본 소프트웨어를 권한 없이 사용하거나 삼성의 사전 서면 동의 없이 제3자에게 공개하는 행위는
   엄격히 금지되어 있으며 위반 시 귀하는 무단 사용 또는 비밀 유지 의무 위반에 대해 법적인 책임을 져야 합니다. This software is the intellectual
   property and confidential information of Samsung Electronics, Co., Ltd. (“Samsung”) protected by
   applicable laws. The unauthorized use or disclosure of the software to any third party without
   the prior written consent of Samsung is strictly prohibited, and you should be legally
  responsible for the unauthorized use or violation of confidentiality obligation.
-->
<!--
Program: QuarterCondition
Author: SDL
Description: QuarterCondition Common Component
-->
<!---->
<template>
  <div class="col-12 quarter-group">
    <div class="col-6 input-group from">
      <wj-combo-box :displayMemberPath="'critrInfoItemNm'" :itemsSource="quarterType"
                    :initialized="initQuarterTypeCombo" class="form-control"
                    :textChanged="changeTypeCombo"></wj-combo-box>
      <wj-combo-box :displayMemberPath="'critrInfoItemNm'" :itemsSource="comboYear" :initialized="initFromYearCombo"
                    class="form-control"></wj-combo-box>
      <wj-combo-box :displayMemberPath="'critrInfoItemNm'" :itemsSource="comboQuar" :initialized="initFromQuarterCombo"
                    class="form-control"></wj-combo-box>
    </div>
    <span class="fromto">~</span>
    <div class="col-4 input-group to">
      <wj-combo-box :displayMemberPath="'critrInfoItemNm'" :itemsSource="comboYear" :initialized="initToYearCombo"
                    class="form-control w80x"></wj-combo-box>
      <wj-combo-box :displayMemberPath="'critrInfoItemNm'" :itemsSource="comboQuar" :initialized="initToQuarterCombo"
                    class="form-control w80x"></wj-combo-box>
    </div>
  </div>
</template>
<script>
// import { _AddNewHandler } from '@grapecity/wijmo.grid';
import { SDLUtil } from '@/utils';

export default {
  name: 'QuarterCondition',
  data() {
    return {
      quarterType: [],
      // 선택 리스트
      comboYear: [],
      comboQuar: [],
      // Data List
      yearList: [],
      quarterList: [],
      monthList: [],
      quarterTypeComboId: '',
      fromYearComboId: '',
      fromQuarterComboId: '',
      toYearComboId: '',
      toQuarterComboId: '',
    };
  },
  props: {},
  beforeMount() {
    this.curPage = this.currentPage;
    // TYPE
    const inputSectionList = SDLUtil.getCommCodeList({ commCodeTypeId: 'INPUT_SECTION' });
    const inputSectionVal = [];
    inputSectionList.forEach(col => {
      inputSectionVal.push({ critrInfoItemId: col.code, critrInfoItemNm: col.label });
    });
    this.quarterType = inputSectionVal;

    const dt = new Date();
    const inputYearVal = [];
    for (let i = (dt.getFullYear() + 10); i > (dt.getFullYear() - 19); i--) {
      inputYearVal.push({ critrInfoItemId: i, critrInfoItemNm: i });
    }
    this.yearList = inputYearVal;

    // QUARTER
    const inputQuarterList = SDLUtil.getCommCodeList({ commCodeTypeId: 'INPUT_QUARTER' });
    const inputQuarterVal = [];
    inputQuarterList.forEach(col => {
      inputQuarterVal.push({ critrInfoItemId: col.code, critrInfoItemNm: col.label });
    });
    this.quarterList = inputQuarterVal;

    // MONTH
    const inputMonthList = SDLUtil.getCommCodeList({ commCodeTypeId: 'INPUT_MONTH' });
    const inputMonthVal = [];
    inputMonthList.forEach(col => {
      inputMonthVal.push({ critrInfoItemId: col.code, critrInfoItemNm: col.label });
    });
    this.monthList = inputMonthVal;
  },
  computed: {},
  methods: {
    initQuarterTypeCombo(combo) {
      this.quarterTypeComboId = combo;
    },
    initFromYearCombo(combo) {
      this.fromYearComboId = combo;
    },
    initFromQuarterCombo(combo) {
      this.fromQuarterComboId = combo;
    },
    initToYearCombo(combo) {
      this.toYearComboId = combo;
    },
    initToQuarterCombo(combo) {
      this.toQuarterComboId = combo;
    },
    getComboVal() {
      const rtnList = {
        quarterTypeComboVal: this.quarterTypeComboId.itemsSource === null || this.quarterTypeComboId.itemsSource.length === 0 || this.quarterTypeComboId.selectedValue.critrInfoItemId === '' ? '' : this.quarterTypeComboId.selectedValue.critrInfoItemId,
        fromYearComboVal: this.fromYearComboId.itemsSource === null || this.fromYearComboId.itemsSource.length === 0 || this.fromYearComboId.selectedValue.critrInfoItemId === '' ? '' : this.fromYearComboId.selectedValue.critrInfoItemId,
        fromQuarterComboVal: this.fromQuarterComboId.itemsSource === null || this.fromQuarterComboId.itemsSource.length === 0 || this.fromQuarterComboId.selectedValue.critrInfoItemId === '' ? '' : this.fromQuarterComboId.selectedValue.critrInfoItemId,
        toYearComboVal: this.toYearComboId.itemsSource === null || this.toYearComboId.itemsSource.length === 0 || this.toYearComboId.selectedValue.critrInfoItemId === '' ? '' : this.toYearComboId.selectedValue.critrInfoItemId,
        toQuarterComboVal: this.toQuarterComboId.itemsSource === null || this.toQuarterComboId.itemsSource.length === 0 || this.toQuarterComboId.selectedValue.critrInfoItemId === '' ? '' : this.toQuarterComboId.selectedValue.critrInfoItemId,
      };
      return rtnList;
    },
    changeComboVal(comboData) {
      setTimeout(() => {
        this.$nextTick(() => {
          this.quarterTypeComboId.text = comboData.quarterType;
        });
      }, 100);
      setTimeout(() => {
        this.$nextTick(() => {
          this.fromYearComboId.text = comboData.fromYear || '';
        });
      }, 100);
      setTimeout(() => {
        this.$nextTick(() => {
          this.fromQuarterComboId.text = comboData.fromQuarter || '';
        });
      }, 100);
      setTimeout(() => {
        this.$nextTick(() => {
          this.toYearComboId.text = comboData.toYear || '';
        });
      }, 100);
      setTimeout(() => {
        this.$nextTick(() => {
          this.toQuarterComboId.text = comboData.toQuarter || '';
        });
      }, 300);
    },
    changeTypeCombo() {
      if (['I001, I002, I003'].includes(this.quarterTypeComboId.selectedValue.critrInfoItemId)) {
        const dt = new Date();
        setTimeout(() => {
          this.$nextTick(() => {
            this.fromYearComboId.text = dt.getFullYear();
            this.toYearComboId.text = dt.getFullYear();
          });
        }, 100);
      }
      switch (this.quarterTypeComboId.selectedValue.critrInfoItemId) {
        case 'I001': // YEAR
          this.fromYearComboId.isDisabled = false;
          this.toYearComboId.isDisabled = false;
          this.fromQuarterComboId.isDisabled = true;
          this.toQuarterComboId.isDisabled = true;
          this.comboYear = [];
          this.comboQuar = [];
          this.comboYear = this.yearList;
          break;
        case 'I002': // QUARTER
          this.fromYearComboId.isDisabled = false;
          this.toYearComboId.isDisabled = false;
          this.fromQuarterComboId.isDisabled = false;
          this.toQuarterComboId.isDisabled = false;
          this.comboYear = [];
          this.comboQuar = [];
          this.comboYear = this.yearList;
          this.comboQuar = this.quarterList;

          setTimeout(() => {
            this.$nextTick(() => {
              this.toQuarterComboId.text = 'Q4';
            });
          }, 100);

          break;
        case 'I003': // MONTH
          this.fromYearComboId.isDisabled = false;
          this.toYearComboId.isDisabled = false;
          this.fromQuarterComboId.isDisabled = false;
          this.toQuarterComboId.isDisabled = false;
          this.comboYear = [];
          this.comboQuar = [];
          this.comboYear = this.yearList;
          this.comboQuar = this.monthList;
          break;
        case 'I004': // NONE
          this.fromYearComboId.isDisabled = true;
          this.toYearComboId.isDisabled = true;
          this.fromQuarterComboId.isDisabled = true;
          this.toQuarterComboId.isDisabled = true;
          this.comboYear = [];
          this.comboQuar = [];
          break;
        default:
          this.fromYearComboId.isDisabled = true;
          this.toYearComboId.isDisabled = true;
          this.fromQuarterComboId.isDisabled = true;
          this.toQuarterComboId.isDisabled = true;
          this.comboYear = [];
          this.comboQuar = [];
          break;
      }
    },
    changeTypeNone(diabled) {
      this.quarterTypeComboId.isDisabled = diabled;
    },
    changeTypeInit() {
      this.quarterTypeComboId.isDisabled = false;

      setTimeout(() => {
        this.$nextTick(() => {
          this.quarterTypeComboId.text = 'QUARTER';
        });
      }, 100);

      this.changeTypeCombo();
    },
  },
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/common/control/quarterCondition/QuarterCondition.vue